<div class="config-form-body">
	@if (dataLoaded) {
		<!-- 1ª Opção: Permitir ligar/desligar MyAsset no cliente -->
		<div class="config-section">
			<h3 class="section-subtitle">{{ labels.lbl_status_geral_myasset || 'Status do MyAsset' }}</h3>
			<div class="toggle-row">
				<span class="description-text">Ativar o monitoramento de ativos e geração de inconsistências para o cliente</span>
				@if (dataLoaded) {
					<cpi-toggle-switch [switchOn]="settings.myAssetEnabled" (switchOnChange)="settings.myAssetEnabled = $event">
					</cpi-toggle-switch>
				}
			</div>
		</div>

		<hr class="section-divider" />

		<!-- 2ª Opção: Gerenciar tipos de inconsistência habilitadas por cliente -->
		<div class="config-section">
			<h3 class="section-subtitle">
				{{ labels.lbl_tipos_inconsistencias_habilitadas || 'Tipos de Inconsistência Habilitados' }}
			</h3>
			<span class="description-text">Selecione quais inconsistências devem ser ativadas e validadas</span>
			<div class="checkbox-grid">
				@for (type of availableInconsistenciesTypes; track type.id) {
					<div class="checkbox-card" [ngClass]="{ checked: isInconsistencyEnabled(type.id) }">
						<label class="checkbox-label">
							<input type="checkbox" [checked]="isInconsistencyEnabled(type.id)" (change)="toggleInconsistency(type.id)" />
							<span class="label-text">{{ labels[type.label] || type.type }}</span>
						</label>
					</div>
				}
			</div>
		</div>

		<hr class="section-divider" />

		<!-- 3ª Opção: Gerenciar prioridade da inconsistência -->
		<div class="config-section">
			<h3 class="section-subtitle">{{ labels.lbl_prioridade_inconsistencia || 'Prioridade das Inconsistências' }}</h3>
			<span class="description-text">Defina a prioridade de atendimento padrão para cada inconsistência habilitada</span>

			<div class="priority-grid">
				@for (type of availableInconsistenciesTypes; track type.id) {
					@if (isInconsistencyEnabled(type.id)) {
						<div class="priority-card">
							<span class="priority-label">{{ labels[type.label] || type.type }}</span>
							<div class="priority-select-wrapper">
								<select [(ngModel)]="settings.inconsistencyPriorities[type.id]" class="priority-select">
									<option value="">Selecione</option>
									<option value="Baixa">Baixa</option>
									<option value="Média">Média</option>
									<option value="Alta">Alta</option>
								</select>
							</div>
						</div>
					}
				} @empty {
					<div class="empty-priority-warning">
						Habilite pelo menos um tipo de inconsistência acima para configurar suas prioridades.
					</div>
				}
			</div>
		</div>

		<hr class="section-divider" />

		<!-- 4ª Opção: Gerenciar tipos de CIs considerados -->
		<div class="config-section">
			<h3 class="section-subtitle">{{ labels.lbl_tipos_ci_gerador || 'Tipos de Itens de Configuração (CI)' }}</h3>
			<span class="description-text">Selecione os tipos de CIs principais que o gerador de inconsistências deve analisar</span>
			<div class="checkbox-grid">
				@for (ciType of availableOnlyCiTypes; track ciType.ciType) {
					<div class="checkbox-card" [ngClass]="{ checked: isCiTypeEnabled(ciType.ciType) }">
						<label class="checkbox-label">
							<input type="checkbox" [checked]="isCiTypeEnabled(ciType.ciType)" (change)="toggleCiType(ciType.ciType)" />
							<span class="label-text">{{ labels[ciType.type] || ciType.type || ciType.ciType }}</span>
						</label>
					</div>
				}
			</div>
		</div>

		<hr class="section-divider" />

		<!-- 5ª Opção: Gerenciar subtipos de CIs considerados -->
		<div class="config-section">
			<h3 class="section-subtitle">{{ labels.lbl_subtipos_ci_gerador || 'Subtipos de Itens de Configuração (CI)' }}</h3>
			<span class="description-text">Especifique os subtipos válidos para análise com base nos tipos de CIs ativados</span>
			<div class="checkbox-grid">
				@for (subType of availableCiSubtypes; track subType.subType) {
					@if (isCiTypeEnabled(subType.ciType)) {
						<div class="checkbox-card" [ngClass]="{ checked: isCiSubtypeEnabled(subType.subType) }">
							<label class="checkbox-label">
								<input
									type="checkbox"
									[checked]="isCiSubtypeEnabled(subType.subType)"
									(change)="toggleCiSubtype(subType.subType)" />
								<span class="label-text">
									{{ labels[subType.type] || subType.type || subType.subType }}
									({{ labels[getParentTypeName(subType.ciType)] || getParentTypeName(subType.ciType) || subType.ciType }})
								</span>
							</label>
						</div>
					}
				} @empty {
					<div class="empty-priority-warning">
						Não há subtipos disponíveis ou nenhum tipo de CI pai correspondente está habilitado.
					</div>
				}
			</div>
		</div>

		<div class="footer-actions">
			<msp-button (click)="saveSettings()" [loading]="isSaving">
				{{ labels.lbl_geral_salvar || 'Salvar Configurações' }}
			</msp-button>
		</div>
	} @else {
		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	}
</div>
